import { createAction, props } from '@ngrx/store';
import {
  ICustomerCompany,
  ICustomerRole,
  ICustomerUser,
  ICustomizedValue,
  IJobTitle,
  ImportCustomizedValueErrorType,
  ISettingsOutputCheck
} from '../models/settings.model';

export const GetSettingsUsersData = createAction('[Settings Users] Get users data');
export const GetSettingsUsersDataSuccess = createAction(
  '[Settings Users] Get users data success',
  props<{ users: ICustomerUser[]; roles: ICustomerRole[]; companies: ICustomerCompany[] }>()
);
export const GetSettingsUsersDataFailed = createAction('[Settings Users] Get users data failed', props<{ error: Error }>());

export interface ICreateUserByUserData {
  firstName: string;
  middleName: string;
  surname: string;
  role: string;
  email: string;
  companyId: string;
  isActive: boolean;
}
export const CreateUserByUser = createAction(
  '[Settings Users] Create user by user',
  props<{ payload: ICreateUserByUserData }>()
);
export const CreateUserByUserSuccess = createAction(
  '[Settings Users] Create user by user success',
  props<{ payload: ICustomerUser }>()
);
export const CreateUserByUserFailed = createAction('[Settings Users] Create user by user failed', props<{ error: Error }>());

export interface IUpdateUserByUser {
  id: string;
  firstName?: string;
  middleName?: string;
  surname?: string;
  role?: string;
  isActive?: string;
  jobTitle?: string | null;
}
export const UpdateUserByUser = createAction(
  '[Settings Users] Update user by user',
  props<{ payload: IUpdateUserByUser }>()
);
export const UpdateUserByUserSuccess = createAction(
  '[Settings Users] Update user by user success',
  props<{ payload: ICustomerUser }>()
);
export const UpdateUserByUserFailed = createAction('[Settings Users] Update user by user failed', props<{ error: Error }>());

export const ResetUserPasswordByUser = createAction(
  '[Settings Users] Reset user password by user',
  props<{ userID; email }>()
);
export const ResetUserPasswordByUserSuccess = createAction('[Settings Users] Reset user password by user success');
export const ResetUserPasswordByUserFailed = createAction(
  '[Settings Users] Reset user password by user failed',
  props<{ error: Error }>()
);

export const GetCustomizedValues = createAction('[Settings Customized Values] Get customized values');
export const GetCustomizedValuesSuccess = createAction(
  '[Settings Customized Values] Get customized values success',
  props<{ customizedValues: ICustomizedValue[] }>()
);
export const GetCustomizedValuesFailed = createAction(
  '[Settings Customized Values] Get customized values failed',
  props<{ error: Error }>()
);

export const AddCustomizedValue = createAction(
  '[Settings Customized Values] Add customized value',
  props<{ customizedValue: Pick<ICustomizedValue, 'key' | 'value' | 'group'> }>()
);
export const AddCustomizedValueSuccess = createAction(
  '[Settings Customized Values] Add customized value success',
  props<{ customizedValue: ICustomizedValue }>()
);
export const AddCustomizedValueFailed = createAction(
  '[Settings Customized Values] Add customized value failed',
  props<{ error: Error }>()
);

export const UpdateCustomizedValue = createAction(
  '[Settings Customized Values] Update customized value',
  props<{ customizedValue: Pick<ICustomizedValue, 'key' | 'value' | 'group' | 'id'> }>()
);
export const UpdateCustomizedValueSuccess = createAction(
  '[Settings Customized Values] Update customized value success',
  props<{ customizedValue: ICustomizedValue }>()
);
export const UpdateCustomizedValueFailed = createAction(
  '[Settings Customized Values] Update customized value failed',
  props<{ error: Error }>()
);

export const DeleteCustomizedValue = createAction(
  '[Settings Customized Values] Delete customized value',
  props<{ id: string }>()
);
export const DeleteCustomizedValueSuccess = createAction(
  '[Settings Customized Values] Delete customized value success',
  props<{ id: string }>()
);
export const DeleteCustomizedValueFailed = createAction(
  '[Settings Customized Values] Delete customized value failed',
  props<{ error: Error }>()
);

export const ImportCustomizedValues = createAction(
  '[Settings Customized Values] Import customized values',
  props<{ formData: FormData }>()
);
export const ImportCustomizedValuesSuccess = createAction(
  '[Settings Customized Values] Import customized values success',
  props<{ newValues: ICustomizedValue[]; importError: ImportCustomizedValueErrorType | null }>()
);
export const ImportCustomizedValuesFailed = createAction(
  '[Settings Customized Values] Import customized values failed',
  props<{ error: Error }>()
);
export const ClearCustomizedValuesImportError = createAction(
  '[Settings Customized Values] Clear customized values import error'
);
export const GetSettingsOutputChecks = createAction('[Settings Output checks] Get settings output checks');
export const GetSettingsOutputChecksSuccess = createAction(
  '[Settings Output checks] Get settings output checks success',
  props<{ outputChecks: ISettingsOutputCheck[] }>()
);
export const GetSettingsOutputChecksFailed = createAction(
  '[Settings Output checks] Get settings output checks failed',
  props<{ error: Error }>()
);

export const GetJobTitles = createAction('[Settings Users] Get job titles');
export const GetJobTitlesSuccess = createAction(
  '[Settings Users] Get job titles success',
  props<{ jobTitles: IJobTitle[] }>()
);
export const GetJobTitlesFailed = createAction('[Settings Users] Get job titles failed', props<{ error: Error }>());

export const CreateJobTitle = createAction(
  '[Settings Users] Create job title',
  props<{ jobTitle: string; jobType: string | null; relatedRole: string | null; active: boolean }>()
);
export const UpdateJobTitle = createAction(
  '[Settings Users] Update job title',
  props<{ jobTitle: string; jobTitleId: string; jobType: string | null; relatedRole: string | null; active: boolean }>()
);
export const UpsertJobTitleSuccess = createAction(
  '[Settings Users] Upsert job title success',
  props<{ jobTitle: IJobTitle }>()
);
export const UpsertJobTitleFailed = createAction('[Settings Users] Upsert job title failed', props<{ error: Error }>());
